import { useState, useCallback } from 'react';
import { readingPracticeRequestsService } from '../../../services/request-service';

export const useSearchReadingPractices = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const searchPractices = useCallback(async (params) => {
    setIsLoading(true);
    setError(null);
    try {
      const result = await readingPracticeRequestsService.searchRequests(params);
      setData(result);
      return result;
    } catch (err) {
      setError(err.message || 'Failed to search reading practices');
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { searchPractices, isLoading, error, data };
};
